import type { UserTodoItem } from '@dreamai/types';

export interface TodoProvenanceLabel {
  /** Who added the task, when it wasn't the viewer. */
  addedBy: { name: string; guest: boolean } | null;
  /** Who last edited the task's text/date/priority/assignee, when it wasn't the viewer. */
  editedBy: string | null;
}

const SOMEONE = 'Someone';

/**
 * Attribution to show on a shared-list task row: who added it and who last
 * changed it, from the viewer's point of view. Nothing is returned for a task
 * the viewer wrote and nobody else has touched.
 */
export function describeTodoProvenance(
  todo: Pick<
    UserTodoItem,
    | 'createdByUserId'
    | 'createdByName'
    | 'createdByGuest'
    | 'lastEditedByUserId'
    | 'lastEditedByName'
  >,
  viewerUserId: string | undefined,
): TodoProvenanceLabel {
  const addedByOther =
    !!todo.createdByUserId && todo.createdByUserId !== viewerUserId;
  const editedByOther =
    !!todo.lastEditedByUserId && todo.lastEditedByUserId !== viewerUserId;
  return {
    addedBy: addedByOther
      ? { name: todo.createdByName || SOMEONE, guest: !!todo.createdByGuest }
      : null,
    editedBy: editedByOther ? todo.lastEditedByName || SOMEONE : null,
  };
}

/** Message body from an axios-style API error, if the server sent one. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const maybe = err as { response?: { data?: { error?: string } } };
  return maybe?.response?.data?.error || fallback;
}
